import React from 'react';
import { Button } from 'rsuite';
import { cssVars } from '@/app/styles';
import styled from 'styled-components';
import { POLICY_CONTENT } from '../policy-config';
import { Close } from '@rsuite/icons';
const AcceptButton = styled(Button)`
  width: 120px;
  height: 36px;
  border-radius: 6px;
  margin-right: 10px;
  border: solid 1px ${cssVars.color.helpPageColor.white};
  color: ${cssVars.loginColors.bannerText};
`;

const CloseButton = styled(Close)`
  width: 14px;
  height: 14px;
  cursor: pointer;
  margin-left: auto;
  margin-right: 20px;
`;

const TextButton = styled.span`
  cursor: pointer;
  text-decoration: underline;
  color: ${cssVars.loginColors.bannerText};
  font-family: Lato;
  height: 14px;
  font-size: 14px;
`;

const TextContainer = styled.span`
  width: 830px;
  color: ${cssVars.loginColors.bannerText};
  font-family: Lato;
  font-size: 14px;
  margin-left: auto;
  margin-right: 8px;
`;

const BannerContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 70px;
  -webkit-backdrop-filter: blur(6px);
  backdrop-filter: blur(6px);
  box-shadow:
    0 2px 3px 0 rgba(8, 10, 37, 0.03),
    0 4px 8.5px 0 rgba(8, 10, 37, 0.05),
    0 7.5px 35px 0 rgba(89, 126, 247, 0.03);
  background-color: ${cssVars.loginColors.policyBackground};
  color: ${cssVars.loginColors.bannerText};
  position: absolute;
  bottom: 0;
`;

export function Banner(props) {
  /**
   * helper method to open policy content with desired tab open.
   * @param {*} contentName: the name of the tab which should be open when policy content is opened.
   */
  const openContentPage = (contentName) => {
    props.setActivePolicyContent(contentName);
    props.setPolicyPageActive(true);
  };
  return (
    <BannerContainer>
      <TextContainer>
        Rentalscape uses cookies to improve your experience. By using our site,
        you agree to our{' '}
        <TextButton onClick={() => openContentPage(POLICY_CONTENT.COOKIES)}>
          {POLICY_CONTENT.COOKIES}
        </TextButton>
        ,{' '}
        <TextButton onClick={() => openContentPage(POLICY_CONTENT.PRIVACY)}>
          {POLICY_CONTENT.PRIVACY}
        </TextButton>
        , and{' '}
        <TextButton onClick={() => openContentPage(POLICY_CONTENT.TERMS)}>
          {POLICY_CONTENT.TERMS}
        </TextButton>
        .
      </TextContainer>
      <AcceptButton
        appearance="ghost"
        onClick={() => {
          props.setPolicyAccepted(true);
          localStorage.setItem('policyAgreement', true);
        }}
      >
        Accept
      </AcceptButton>
      <CloseButton icon="close" onClick={() => props.setPolicyAccepted(true)} />
    </BannerContainer>
  );
}
